import type { IconData } from '@stacksjs/iconify-core'

export const book1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 46.5c-3.31 0-6.133-.068-8.5-.169V1.67a200 200 0 0 1 8.5-.169c6.41 0 10.991.254 13.976.51c3.297.282 5.791 2.858 6.032 6.135c.24 3.267.492 8.455.492 15.855s-.252 12.588-.492 15.855c-.24 3.277-2.735 5.853-6.032 6.135c-2.985.256-7.567.51-13.976.51M20 12a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4H22a2 2 0 0 1-2-2m2 7a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4zM10.024 2.01q1.093-.095 2.476-.183v44.347a113 113 0 0 1-2.476-.184c-3.297-.282-5.791-2.858-6.032-6.135C3.752 36.588 3.5 31.4 3.5 24s.252-12.588.492-15.855c.24-3.276 2.735-5.853 6.032-6.135\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default book1Solid
